import { Container, FloatButton } from './styles'
import { FaHome, FaHotel, FaThList } from 'react-icons/fa'
import { RiMapPin2Fill, RiSideBarFill, RiCloseFill, RiDoorOpenFill } from 'react-icons/ri'
import { BsTagFill } from 'react-icons/bs'
import { Link } from 'react-router-dom';
import { useUserContext } from "../contexts/useUserContext";
import { useState, useEffect } from 'react'
import { api } from '../../services/api';

export const Sidebar = () => {
  const { user } = useUserContext();
  const [sidebar, setSidebar] = useState(true);
  const [adminPermissions, setAdminPermissions] = useState([]);

  const showSidebar = () => {
    setSidebar(!sidebar)
  }

  useEffect(() => {
    api.get('/permissions/index')
    .then(response => {
      let permissions = []
      response.data.forEach((permission) => {
        if (user.permissions.indexOf(permission.id) !== -1)
          permissions.push(permission.name)
      })
      setAdminPermissions(permissions)
    })
  }, [user])

  return (
    <>
    <FloatButton onClick={showSidebar}>
      <RiSideBarFill className='icon'/>
    </FloatButton>
    <Container active={sidebar}>
      <div className='sidebar'>
        <RiCloseFill className='icon close' onClick={showSidebar}/>
        <div className='top-list'>
          <span>Usuário Logado:</span>
          <span>{user?.name}</span>
          <Link to='/admindashboard' className="text-link">
          <div className='title'>
            <FaHome className='icon'/>
            <span>Página Inicial</span>
          </div>
          </Link>
        </div>
        <div className='midle-list'>
          <ul>
            <Link to='/destinations' className="text-link">
              <li><RiMapPin2Fill className='icon'/><span>Destinos</span></li>
            </Link>
            <Link to='/hotels' className="text-link">
              <li><FaHotel className='icon'/><span>Hotéis</span></li>
            </Link>
            <Link to='/tags' className="text-link">
              <li><BsTagFill className='icon'/><span>Tags</span></li>
            </Link>
            <Link to='/categories' className="text-link">
              <li><FaThList className='icon'/><span>Categorias</span></li>
            </Link>
            <Link to='/room_types' className="text-link">
              <li><RiDoorOpenFill className='icon'/><span>Tipos de Quarto</span></li>
            </Link>
          </ul>
        </div>
        <div className='bottom-list'>
          <ul>
            <Link to='/bookings' className="text-link">
              <li><span>Reservas</span></li>
            </Link>
            { adminPermissions.indexOf('index_clients') !== -1 &&
                <Link to='/manager/clients' className="text-link">
                  <li><span>Usuários</span></li>
                </Link>
            }
            { adminPermissions.indexOf('index_clients') !== -1 &&
                <Link to='/manager/clients_solicitations' className="text-link">
                  <li><span>Solicitações de Destinos</span></li>
                </Link>
            }
            { adminPermissions.indexOf('index_retailers') !== -1 &&
              <Link to='/manager/retailers' className="text-link">
                <li><span>Revendedores</span></li>
              </Link>
            }
            { adminPermissions.indexOf('modify_permissions') !== -1 &&
              <Link to='/manager/admins' className="text-link">
                <li><span>Administradores</span></li>
              </Link>
            }
            <Link to='/payoptions' className="text-link">
              <li><span>Opções de pagamento</span></li>
            </Link>
          </ul>
        </div>
      </div>
    </Container>
    </>
  )
}

export default Sidebar